<div
  class="drop-zone"
  (dragover)="onDragOver($event)"
  (drop)="onDrop($event)"
  (click)="fileInput.click()"
>

  <div *ngIf="!previewUrl && person?.imageUrl" class="image-preview">
    <img [src]="person.imageUrl" alt="Preview" class="thumbnail" />
    <mat-icon class="delete-button" (click)="deleteImage($event)" *ngIf="person.imageUrl.includes('family_room_directory')">delete</mat-icon>
  </div>
  <div *ngIf="previewUrl" class="image-preview">
    <img [src]="previewUrl" alt="Preview" class="thumbnail" />
    <mat-icon class="delete-button" (click)="deleteImage($event)">delete</mat-icon>
  </div>
  <ng-container *ngIf="!previewUrl">
    <p>Drag & drop an image, or click to upload</p>
  </ng-container>
  <input
    #fileInput
    type="file"
    [attr.accept]="'image/*'"
    hidden
    (change)="onFileSelected($event)"
  />
</div>
